import { Box, Button, Flex, IconButton, Image, Text } from "@chakra-ui/core";
import React from "react";

import logoIcon from "../../assets/logo.png";
import {
  APP_DOWNLOAD_PATH,
  detectMobilePlatform,
  useStoreUrls,
} from "../../services/app-download.service";

// „Verzió 3 — mobil tapadó sáv". A jobb alsó sarokban fixen ott a Széchenyi
// infoblokk (CompetitionLogo, ≤600px: 120px, fölötte 160px széles), amit nem
// takarhatunk el, ezért a sáv fölötte ül (a logó magassága kb. 83px / 110px).

function AppPromoBar({
  onClose,
  onStoreClick,
}: {
  onClose: () => void;
  onStoreClick: () => void;
}): JSX.Element {
  const storeUrls = useStoreUrls();
  const platform = detectMobilePlatform();
  // Ismeretlen mobil böngészőnél a köztes oldal mutatja mindkét badge-et.
  const href = platform ? storeUrls[platform] : APP_DOWNLOAD_PATH;

  return (
    <Box
      position="fixed"
      left="10px"
      right="10px"
      bottom={["92px", "120px"]}
      zIndex={1001}
    >
      <Flex
        position="relative"
        alignItems="center"
        p="10px 12px"
        borderRadius="14px"
        backgroundColor="#fff"
        color="#1c1c1c"
        boxShadow="0 10px 30px rgba(0,0,0,.35)"
      >
        <Flex
          flex="none"
          w="46px"
          h="46px"
          mr="12px"
          borderRadius="11px"
          backgroundColor="#da1515"
          alignItems="center"
          justifyContent="center"
        >
          <Image src={logoIcon} height="38px" width="auto" />
        </Flex>
        <Box flex="1" minW={0} mr="10px">
          <Text fontSize="15px" fontWeight={800} lineHeight="1.2">
            Pizza Sprint app
          </Text>
          <Text fontSize="12.5px" lineHeight="1.3" color="#5a6069" isTruncated>
            Gyorsabb rendelés, kuponok, hűségpont
          </Text>
        </Box>
        <Button
          as="a"
          // @ts-ignore — Chakra 0.7: az `as="a"` gomb típusa nem ismeri a href-et
          href={href}
          onClick={onStoreClick}
          flex="none"
          height="38px"
          px="16px"
          borderRadius="10px"
          fontSize="14px"
          fontWeight={700}
          color="#fff"
          backgroundColor="#e8322a"
          _hover={{ backgroundColor: "#c9261f" }}
        >
          Letöltés
        </Button>
        <IconButton
          onClick={onClose}
          aria-label="Bezárás"
          icon="close"
          size="xs"
          isRound
          position="absolute"
          top="-9px"
          right="-6px"
          fontSize="8px"
          color="#5a6069"
          backgroundColor="#fff"
          boxShadow="0 1px 4px rgba(0,0,0,.25)"
          _hover={{ backgroundColor: "#f1f2f4" }}
        />
      </Flex>
    </Box>
  );
}

export default AppPromoBar;
